(function () {
  function initCardColorSwatches(root = document) {
    const swatches = root.querySelectorAll('.card-color-swatch');

    swatches.forEach((swatch) => {
      if (swatch.dataset.swatchReady === 'true') return;

      swatch.dataset.swatchReady = 'true';

      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const card = swatch.closest('.card-wrapper');

        if (!card) return;

        const imageSrc = swatch.dataset.imageSrc;
        const imageSrcset = swatch.dataset.imageSrcset;
        const imageAlt = swatch.dataset.imageAlt;
        const variantUrl = swatch.dataset.variantUrl;

        /*
         * Find the main product image
         */
        const images = card.querySelectorAll('.card__media img');
        const mainImage = images[0];

        /*
         * Swap to selected color image
         */
        if (mainImage && imageSrc) {
          mainImage.src = imageSrc;

          if (imageSrcset) {
            mainImage.srcset = imageSrcset.trim();
          }

          if (imageAlt) {
            mainImage.alt = imageAlt;
          }
        }

        /*
         * Hide Spotlight's secondary hover image after
         * the customer has intentionally selected a color.
         */
        if (images.length > 1) {
          for (let i = 1; i < images.length; i++) {
            images[i].style.display = 'none';
          }
        }

        /*
         * Update selected swatch
         */
        card.querySelectorAll('.card-color-swatch').forEach((item) => {
          item.classList.remove('card-color-swatch--active');
          item.removeAttribute('aria-current');
        });

        swatch.classList.add('card-color-swatch--active');
        swatch.setAttribute('aria-current', 'true');

        /*
         * Update product links so clicking the product afterward
         * opens the selected color variant.
         */
        if (variantUrl) {
          const productLinks = card.querySelectorAll(
            '.card__heading a'
          );

          productLinks.forEach((link) => {
            link.href = variantUrl;
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCardColorSwatches();
    });
  } else {
    initCardColorSwatches();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCardColorSwatches(event.target);
  });
})();